'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index2 = require('../../index');

var _picker = require('./picker.vue');

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
var modal = weex.requireModule('modal');
var animation = weex.requireModule('animation');
exports.default = _defineProperty({
  components: {
    picker: _picker2.default
  },
  props: {
    // mode:String,
    mode: {
      type: String,
      default: 'selector' //picker类型 'selector'/'multiselector'
    },
    listArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    wrapWidth: {
      type: Array,
      default: []
    },
    itemIndex: {
      type: Array,
      // default: [0]
      default: function _default() {
        return new Array(this.listArray.length).fill(0);
      }
    },
    label: {
      type: Array,
      default: []
    },
    labelOffset: {
      type: Number,
      default: null
    },
    align: {
      type: String,
      default: 'center' // 'center'/'left'
    }
  },
  data: function data() {
    return {
      indexArr: [], //picker索引集合
      timeArr: [],
      timelabelArr: ['时', '分'],
      timeRadiusArr: ['left', 'right'],
      timeItemIndexArr: [10, 30]
    };
  },
  created: function created() {
    var mode = this.mode;

    if (mode == 'time') {
      var hourList = [],
          minutesList = [];
      for (var index = 0; index < 24; index++) {
        hourList.push({ index: index, value: index });
      }
      for (var _index = 0; _index < 60; _index++) {
        minutesList.push({ index: _index, value: _index });
      }
      this.timeArr = [hourList, minutesList];
    }
  },
  mounted: function mounted() {
    var mode = this.mode;

    mode == 'time' ? this.currentTime() : '';
  },


  computed: {
    multiLen: function multiLen() {
      var wrapWidth = this.wrapWidth;

      var sum = 0;
      wrapWidth.forEach(function (item) {
        sum = sum + item;
      });
      console.log("sum", sum);
      return sum;
    }
  },

  watch: {
    itemIndex: {
      handler: function handler(newVal) {
        this.indexArr = newVal;
      },

      immediate: true
    }
  },
  methods: {
    selectAreaType: function selectAreaType(index) {
      var listArray = this.listArray;

      if (index == 0) {
        return 'left';
      }
      if (0 < index < listArray.length - 1) {
        return 'mid';
      }
      if (index == listArray.length - 1) {
        return 'right';
      }
    },
    currentTime: function currentTime() {
      var hour = void 0,
          minutes = void 0,
          curTime = new Date();
      hour = curTime.getHours(); //获取当前小时数(0-23)
      minutes = curTime.getMinutes(); //获取当前分钟数(0-59)
      console.log('hour:' + hour + ', minutes:' + minutes);
    },


    // 单列选择
    singleChangeValue: function singleChangeValue(event) {
      var listArray = this.listArray;
      // Core.toast(`column:${0}, event.index${event.index}`)

      var selectData = { index: event.index, value: listArray[event.index].value };
      this.$emit('onChange', selectData);
    },
    changeValue: function changeValue(event, columnIndex) {
      var listArray = this.listArray;
      // Core.toast(`column:${columnIndex}, event.index${event.index}`)

      this.indexArr[columnIndex] = event.index;
      var selectData = [];
      for (var index = 0; index < listArray.length; index++) {
        selectData.push({ index: this.indexArr[index], value: listArray[index][this.indexArr[index]].value });
      }
      // this.$emit('onChange', this.listArray[event.index]);
      this.$emit('onChange', selectData);
    },


    // 时间picker事件
    changeTimeValue: function changeTimeValue(event, columnIndex) {
      var mode = this.mode,
          timeItemIndexArr = this.timeItemIndexArr;
      // Core.toast(`column:${columnIndex}, event.index${event.index}`)

      this.timeItemIndexArr[columnIndex] = event.index;
      var selectData = [];
      for (var index = 0; index < 2; index++) {
        selectData.push({ index: index, value: timeItemIndexArr[index] });
      }
      this.$emit('onChange', selectData);
    }
  }
}, 'mounted', function mounted() {});


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-picker/index.vue
// module id = 366
// module chunks = 0 1